export default __webpack_public_path__ + "static/media/logo.cbab08fc.svg";